import { FC } from "react";
import { UserRole } from "~/api/model";
import { useGetCurrentUser } from "~/api/users/users";

type DisplayForProps = {
  roles: UserRole[];
  children: React.ReactNode;
};

export const DisplayFor: FC<DisplayForProps> = ({ roles, children }) => {
  const { data: user } = useGetCurrentUser();

  if (!user) return null;

  if (!roles.includes(user.role)) return null;

  return <>{children}</>;
};
